import { render, staticRenderFns } from "./RoleAssignmentEdit.vue?vue&type=template&id=626e7a60"
import script from "./RoleAssignmentEdit.vue?vue&type=script&lang=js"
export * from "./RoleAssignmentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports